/**
 * Replaces all special characters with their escaped version
 * Meant for use with user provided string that ends up in new RegExp()
 */
export const escapeRegex = (input: string) => input.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
